import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "pages-service";

export default {
    getGuidelines() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/pages/merchant/guidelines", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    saveGuidelines(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/pages/merchant/guidelines", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
